export const SITE = {
    name: "5 Star Construction Services LLC",
    short: "5 Star Construction",
    city: "Medford, Oregon",
    region: "Southern Oregon",
    phoneDisplay: "541-292-9620",
    phoneHref: "tel:+15412929620",
    emailDisplay: "5starhelpllc@gmail.com",
    facebookUrl: "https://www.facebook.com/5starservicellc",
    youtubeUrl: "https://www.youtube.com/@5starhelp",
    youtubeHandle: "@5starhelp",
    ccb: "CCB #232477",
    descriptor: "General Contractor",
    hours: [
        { day: "Mon – Fri", time: "7:00a – 6:00p" },
        { day: "Saturday", time: "8:00a – 4:00p" },
        { day: "Sunday", time: "By appointment" },
        { day: "Emergency", time: "24-hour calls available" },
    ],
    serviceArea: [
        "Medford",
        "Central Point",
        "Eagle Point",
        "Phoenix",
        "Talent",
        "Ashland",
        "White City",
        "Jacksonville",
        "Grants Pass",
        "Vancouver, WA",
        "Battle Ground, WA",
    ],
    license: "Licensed General Contractor · CCB #232477 · Bonded · Insured",
};

export const SERVICES = [
    {
        key: "full",
        title: "Full-Service Handyman",
        blurb:
            "From a sticking door to a punch list a mile long — one call, one crew, finished right. Drywall, paint, plumbing, electrical, doors, windows, floors, trim, fences, fixtures, appliances and more.",
        icon: "Hammer",
        big: true,
        bullets: [
            "Drywall & paint",
            "Light plumbing & leaks",
            "Electrical & fixtures",
            "Doors, windows & trim",
            "Flooring & tile",
            "Fences & decks",
            "Roofing & siding",
            "Appliance hookups",
        ],
    },
    { key: "plumbing", title: "Light Plumbing", blurb: "Faucets, fixtures, P-traps, supply lines.", icon: "Wrench" },
    { key: "leaks", title: "Leak Repairs", blurb: "Find it, stop it, dry it out.", icon: "Droplets" },
    { key: "electrical", title: "Electrical", blurb: "Outlets, switches, fixtures, ceiling fans.", icon: "Plug" },
    { key: "drywall", title: "Drywall & Texture", blurb: "Patch holes, match texture, repaint clean.", icon: "SquareDashed" },
    { key: "painting", title: "Interior & Exterior Painting", blurb: "Prepped, cut-in, two-coat finish.", icon: "PaintRoller" },
    { key: "doors", title: "Doors", blurb: "Hung, planed, weather-sealed, hardware swaps.", icon: "DoorOpen" },
    { key: "windows", title: "Windows", blurb: "Glazing, sash, screens, trim and casing.", icon: "Frame" },
    { key: "flooring", title: "Flooring", blurb: "LVP, laminate, tile patches, subfloor repair.", icon: "LayoutGrid" },
    { key: "roof", title: "Roof Repairs", blurb: "Shingle replacement, flashing, leak chasing.", icon: "Home" },
    {
        key: "manufactured",
        title: "Manufactured Home Setup & Repair",
        blurb:
            "Interior close-ups — tape & texture, doors & detail finishing — plus site work & development, runners, slabs, block & skirting, decks, awnings, garages, and service work. Inside to outside, all brands, with 25 years of experience and set up with all major retailers.",
        icon: "HomeIcon",
        big: true,
        bullets: ["Tape, texture & details", "Doors & finish work", "Site work & block / skirting", "All brands · all retailers"],
    },
];

export const SERVICE_CAPABILITIES = [
    {
        group: "Drywall, Paint & Walls",
        items: [
            "Drywall repair & patching",
            "Wall & ceiling texturing",
            "Popcorn ceiling removal",
            "Interior painting (prep + finish)",
            "Exterior touch-up painting",
            "Caulking & weatherstripping",
        ],
    },
    {
        group: "Plumbing & Fixtures",
        items: [
            "Leak diagnosis & repair",
            "Toilet install & repair",
            "Water heater install & repair",
            "Faucet & fixture swaps",
            "Garbage disposal install",
            "Shower & tub hardware",
        ],
    },
    {
        group: "Doors, Windows & Trim",
        items: [
            "Interior & exterior doors",
            "Door hardware & locks",
            "Window install & repair",
            "Window screen repair",
            "Trim, casing & baseboards",
            "Pet door installation",
        ],
    },
    {
        group: "Floors & Surfaces",
        items: [
            "LVP & LVT flooring",
            "Tile install & repair",
            "Linoleum repair",
            "Subfloor repair",
            "Formica countertop repair",
            "Threshold & transition repair",
        ],
    },
    {
        group: "Appliances & Light Electrical",
        items: [
            "Dishwasher installation",
            "Washer & dryer hookups",
            "Range hood install",
            "Whole-house fan install",
            "Bathroom exhaust fan install",
            "Ceiling fan installation",
            "Light fixture installation",
            "Outlet & switch swaps",
        ],
    },
    {
        group: "Outside the House",
        items: [
            "Fence repair & install",
            "Deck repair & staining",
            "Roofing repair & install",
            "Siding repair & install",
            "Exterior siding patches",
            "Gutter cleaning & repair",
            "Pressure washing",
            "Mailbox & post repair",
        ],
    },
    {
        group: "The Little Stuff",
        items: [
            "TV mounting",
            "Shelving & picture hanging",
            "Towel bars & bath hardware",
            "Smoke & CO detectors",
            "Squeaky doors & door stops",
            "If it's broken — we probably fix it.",
        ],
    },
];

export const TESTIMONIALS = [
    {
        name: "Diane R.",
        location: "Central Point, OR",
        quote:
            "Showed up when they said. Fixed two leaks, hung a new door, and the price was exactly what they quoted.",
    },
    {
        name: "Marcus T.",
        location: "Medford, OR",
        quote:
            "These guys re-leveled and re-skirted our manufactured home in a single weekend. Solid crew.",
    },
    {
        name: "Janet & Bill K.",
        location: "Ashland, OR",
        quote:
            "Drywall patch, texture match, paint — couldn't even find the spot when they were done. Highly recommend.",
    },
];
